/* eslint-disable */
import React from 'react'

const PlayButton = () => {
  return (
    <>
      <path
        d="M44,88C19.7,88,0,68.3,0,44S19.7,0,44,0s44,19.7,44,44S68.3,88,44,88z M44,
        2C20.8,2,2,20.8,2,44s18.8,42,42,42
    s42-18.8,42-42S67.2,2,44,2z"
      />
      <path d="M33.3,60.8V27.2L62.5,44L33.3,60.8z M35.3,30.6v26.8L58.5,44L35.3,30.6z" />
    </>
  )
}

export default PlayButton
